import { FC, JSX, useEffect, useState } from "react";
import "./Plans.scss";
import MasterPage from "../../MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightArrowLeft,
  faEdit,
  faMoneyCheckDollar,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../providers/PaginateProvider";
import ModalPlansInsert from "../../../components/Financial/Plans/ModalPlansInsert/ModalPlansInsert";
import SidebarPlansFilter from "../../../components/Financial/Plans/SidebarPlansFilter/SidebarPlansFilter";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";
import { usePlans } from "../../../providers/Financial/Plans/PlansProvider";
import { PlansModel } from "../../../models/Financial/Plans/PlansModel";
import ModalPricePlanInsert from "../../../components/Financial/Plans/ModalPricePlanInsert/ModalPricePlanInsert";
import ModalLinkingCategoriesInsert from "../../../components/Financial/Plans/ModalLinkingCategoriesInsert/ModalLinkingCategoriesInsert";
import FormatMoney from "../../../utils/FormatMoney";
import { useAgentsCategories } from "../../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";

interface PlansProps { }

const Plans: FC<PlansProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [showModalPricePlanInsert, setShowModalPricePlanInsert] =
    useState<boolean>(false);
  const [planEdit, setPlanEdit] = useState<PlansModel>({});
  const [
    showModalLinkingCategoriesInsert,
    setShowModalLinkingCategoriesInsert,
  ] = useState<boolean>(false);

  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();
  const { setParams: setParamsAgentsCategories, categoriesOptions } =
    useAgentsCategories();
  const { handlePaginate } = usePaginate();
  const {
    setParams,
    params,
    isLoading,
    plans,
    pages,
    error,
    handleDelete,
    handleList,
  } = usePlans();

  const handleEdit = (item: any) => {
    setPlanEdit(item);
    setShowModalInsert(true);
  };

  const handleDeletePlans = (item: any) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir o ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Plano inativado com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar o Plano.<br>${error}`,
            "error",
          );
        }
      }
    });
  };

  const handlePricePlans = (item: any) => {
    setPlanEdit(item);
    setShowModalPricePlanInsert(true);
  };

  const handleLinkCategories = (item: any) => {
    setPlanEdit(item);
    setShowModalLinkingCategoriesInsert(true);
  };

  const handleClose = () => {
    setPlanEdit({});
    setShowModalInsert(false);
    setShowModalPricePlanInsert(false);
    setShowModalLinkingCategoriesInsert(false);
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {plans?.length > 0 ? (
          <>
            {plans?.map((x: PlansModel, key: number) => {
              const agentCategories =
                categoriesOptions?.filter((opt) =>
                  x?.agent_category?.includes(opt.value),
                ) || [];

              const visibleCategories = agentCategories.slice(0, 5);
              const remainingCount =
                agentCategories.length - visibleCategories.length;
              return (
                <tr key={x.id} className="text-sm">
                  <td className="text-center">{x.id}</td>
                  <td>{x?.name}</td>
                  <td>
                    {x?.description}
                    {x?.agent_category && x?.agent_category?.length > 0 && (
                      <div className="d-flex flex-wrap mt-2">
                        {visibleCategories.map((opt, index) => (
                          <span key={opt.value}>
                            <span className="badge bg-secondary me-1">
                              {opt.label}
                            </span>
                            {index < visibleCategories.length - 1}
                          </span>
                        ))}

                        {remainingCount > 0 && (
                          <b
                            className="ms-1 text-white badge bg-secondary"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleLinkCategories(x)}
                          >
                            +{remainingCount}
                          </b>
                        )}
                      </div>
                    )}
                  </td>
                  <td>{x?.plan_type}</td>
                  <td>
                    <p className="text-sm">
                      <b className="me-1">USUÁRIO:</b>
                      {x?.max_users}
                    </p>

                    {x?.message_limit !== null && (
                      <p className="text-sm">
                        <b className="me-1">MENSAGENS:</b>
                        {x?.message_limit}
                      </p>
                    )}
                  </td>
                  <td>
                    <span
                      className={
                        x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                      }
                    >
                      {x?.deleted_at ? "Inativo" : "Ativo"}
                    </span>
                  </td>
                  <td className="text-center">
                    {x?.plan_prices?.map((price) => (
                      <div className="d-flex" key={price?.cycle}>
                        <b className="me-1">
                          {price?.cycle === "monthly" ? "Mensal:" : "Anual:"}
                        </b>
                        <span>{FormatMoney(price?.price)}</span>
                      </div>
                    ))}
                  </td>
                  <td>
                    {x?.stripe_product_id}
                  </td>
                  <td className="text-center">
                    <DropdownMenuTable key={x?.id}>
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleEdit(x)}
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                        Editar
                      </Dropdown.Item>
                      {!x?.deleted_at && (
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeletePlans(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>
                      )}
                      {!x?.deleted_at && (
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handlePricePlans(x)}
                        >
                          <FontAwesomeIcon
                            icon={faMoneyCheckDollar}
                            className="me-2"
                          />{" "}
                          Preços
                        </Dropdown.Item>
                      )}
                      {!x?.deleted_at && x?.plan_type === "artigos_ia" && (
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleLinkCategories(x)}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRightArrowLeft}
                            className="me-2"
                          />{" "}
                          Vincular Categoria para IA
                        </Dropdown.Item>
                      )}
                    </DropdownMenuTable>
                  </td>
                </tr>
              );
            })}
          </>
        ) : (
          <tr>
            <td colSpan={8} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Descrição
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Tipo Plano
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Máximo
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Status
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Valores
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Id Stripe
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {plans?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      withPaginate: true,
      filter: { only_active: false },
    });
    setParamsAgentsCategories({
      withPaginate: false,
      filter: { only_active: true },
    });
  }, []);

  return (
    <MasterPage title="Plans" icon="fas fa-file" footerFixed>
      <div className="Plans" data-testid="Plans">
        <PageBase
          title="Planos"
          subtitle="Gerenciamento de planos cadastrados"
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
          useButtonGroup
        />

        <ModalPlansInsert
          show={showModalInsert}
          planEdit={planEdit}
          onClose={() => handleClose()}
        />

        <ModalPricePlanInsert
          show={showModalPricePlanInsert}
          plan={planEdit}
          onClose={() => handleClose()}
        />

        <ModalLinkingCategoriesInsert
          show={showModalLinkingCategoriesInsert}
          plan={planEdit}
          onClose={() => handleClose()}
        />
      </div>

      <SidebarPlansFilter />
    </MasterPage>
  );
};

export default Plans;
